export const dispatchStatusEnum = [
  { label: "Pending", value: "Pending" },
  { label: "Dispatch", value: "Dispatch" },
  { label: "InTransit", value: "InTransit" },
  { label: "Arrived", value: "Arrived" },
];

export const getStatusStyles = (status: string) => {
  switch (status) {
    case "Pending":
      return "bg-yellow-50 text-yellow-500 border border-yellow-500";
    case "Dispatch":
      return "bg-blue-50 text-blue-500 border border-blue-500";
    case "InTransit":
      return "bg-orange-50 text-orange-500 border border-orange-500";
    case "Arrived":
      return "bg-purple-50 text-purple-500 border border-purple-500";
    case "Delivered":
      return "bg-green-50 text-green-500 border border-green-500";
    default:
      return "bg-gray-50 text-gray-500 border border-gray-500";
  }
};


  export const orderStatusFilter = [
    { label: "All", value: null },
    { label: "Paid Orders", value: "PAID" },
    { label: "Completed Orders", value: "COMPLETED" },
    { label: "Accepted Orders", value: "ACCEPTED" },
    { label: "Pending Orders", value: "PENDING" },
    { label: "Failed Orders", value: "FAILED" },
    { label: "Rejected Orders", value: "REJECTED" },
    { label: "Canceled Orders", value: "CANCELED" },
  ];

export const dispatchStatusFilter = [
  { label: "All", value: null },
  { label: "Pending", value: "Pending" },
  { label: "Dispatch", value: "Dispatch" },
  { label: "InTransit", value: "InTransit" },
  { label: "Arrived", value: "Arrived" },
];
